import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BgImg from "../Assets/img/medium-education-bg.png";
const MediumEducation = () => {
  const [mediumEducationInfo, setMediumEducationInfo] = useState([]);
  useEffect(() => {
    axios.get("JSON/mediumEducation.json").then((response) => {
      setMediumEducationInfo(response.data[0]);
    });
  }, []);
  return (
    <>
      <section
        className="eschool-medium-education"
        style={{ backgroundImage: `url(${BgImg})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="medium-education-content">
                <h3 className="medium-edu-cont-title">
                  {mediumEducationInfo?.sort_title}
                </h3>
                <div className="medium-edu-content-inner">
                  <h2 className="medium-edu-inner-title">
                    {mediumEducationInfo?.header_title}
                  </h2>
                  <p className="medium-edu-inner-text">
                    {mediumEducationInfo?.detail_one}
                  </p>
                  <p className="medium-edu-inner-text m-0">
                    {mediumEducationInfo?.detail_two}
                  </p>
                  <div className="medium-edu-cont-btn">
                    <Link to="#" className="eschool-btn">
                      Free admission<i className="fi fi-rs-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="medium-edu-img">
                <img src={mediumEducationInfo?.img} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MediumEducation;
